const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  guide: state => state.app.guide,
  token: state => state.user.token,
  departId: state => state.user.departId,
  avatar: state => state.user.avatar,
  userid: state => state.user.userid,
  username: state => state.user.username,
  menus: state => state.user.menus,
  special: state => state.user.special,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js